import React, { Fragment, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Trans, Plural } from '@lingui/react';
import { t } from '@lingui/macro';
import { useLocalisation } from '@3plearning/lingui-cdn';
import './footer.scss';
import Button, { BUTTON_STYLES } from '../button/button';
import Tooltip from '../tooltip/tooltip';
import GenericModal, { MODAL_TYPE } from '../generic-modal/generic-modal';

// Context
import ConsoleModalContext from '../../containers/console/context/console-modal-context';

// Other
import MoveStudents from '../move-students/move-students';
import useIsOneRosterActivatedSchool from '../../hooks/use-is-one-roster-activated-school';
import SignInCardsButton from './components/sign-in-cards-button/sign-in-cards-button';
import DownloadSigninModal from '../download-signin-modal/download-signin-modal';

function Footer({ numOfClassStudents, numOfSelectedStudents, isMinimised, setIsMinimised, classGroupStudents }) {
    const [showDownloadSignInModal, setShowDownloadSignInModal] = useState(false);
    const isOneRosterActivatedSchool = useIsOneRosterActivatedSchool();
    const { i18n } = useLocalisation();
    const { showConsoleModal, setShowConsoleModal, setConsoleModalContent } = useContext(ConsoleModalContext);

    /*
    TODO: if the story about the footer has a requirement to close the button wherever a
    click happens in a minimised state, it should expand
     */
    const toggleHandler = () => {
        setIsMinimised(!isMinimised);
    };
    const hasStudents = numOfClassStudents > 0;
    const hasSelectedStudents = numOfSelectedStudents > 0;

    const closeMoveModal = () => {
        setShowConsoleModal(false);
    };
    const showMoveModal = () => {
        setShowConsoleModal(!showConsoleModal);
        setConsoleModalContent((
            <GenericModal
                title={<Trans id={'Move Modal - Title'} />}
                closeHandler={closeMoveModal}
                isOneRosterActivatedSchool={isOneRosterActivatedSchool}
                type={MODAL_TYPE.floating}>
                <MoveStudents
                    closeHandler={closeMoveModal}
                />
            </GenericModal>
        ));
    };

    // ----- Components -----
    // Component to display the existing numbers as it was expanded
    const minimisedComponent = (
        <Plural
            id="Footer - minimised title - {numOfSelectedStudents}"
            value={numOfSelectedStudents}
            _0="No student selected"
            one="# student selected"
            other="# students selected"
        />
    );
    // Component for the existing mockup for action items on the page
    const expandedComponent = (
        <Fragment>
            <Button
                buttonStyle={BUTTON_STYLES.iconText}
                iconName="movedouble"
                isBtnDisabled={!hasSelectedStudents}
                visibleText={(
                    <Plural
                        id="Footer - Move class - button title - {numOfSelectedStudents}"
                        value={numOfSelectedStudents}
                        _0="Move/remove Students"
                        one="Move/remove Students (#)"
                        other="Move/remove Students (#)"
                    />
                )}
                importedClasses="footer__button"
                callback={showMoveModal}
            />
            <SignInCardsButton
                isOneRosterActivatedSchool={isOneRosterActivatedSchool}
                classGroupStudents={classGroupStudents}
                numOfSelectedStudents={numOfSelectedStudents}
                hasStudents={hasStudents}
                openModal={() => setShowDownloadSignInModal(true)}
            />
        </Fragment>
    );

    return (
        <Fragment>
            {showDownloadSignInModal && (
                <DownloadSigninModal
                    numOfSelectedStudents={numOfSelectedStudents}
                    closeHandler={() => setShowDownloadSignInModal(false)}

                />
            )}
            <footer className={`footer ${isMinimised ? 'footer--minimised' : ''}`}>
                {
                    isMinimised ? '' : <Tooltip visibleTexts={[i18n._(t`Tooltips - footer`)]} position="top" />
                }
                <div className="footer__content">
                    {isMinimised ? minimisedComponent : expandedComponent}
                </div>
                <Button
                    buttonStyle={BUTTON_STYLES.iconSVG}
                    importedClasses="footer__button footer__button--toggle"
                    iconName={isMinimised ? 'maximise' : 'minimise'}
                    callback={toggleHandler}
                    ariaProps={
                        {
                            'aria-label': isMinimised ?
                                i18n._(t`Footer - Toggle footer - Open`) :
                                i18n._(t`Footer - Toggle footer - Close`)
                        }
                    }
                />
            </footer>
        </Fragment>
    );
}

Footer.propTypes = {
    numOfClassStudents: PropTypes.number,
    numOfSelectedStudents: PropTypes.number,
    isMinimised: PropTypes.bool,
    setIsMinimised: PropTypes.func,
    classGroupStudents: PropTypes.array
};

export default Footer;



// WEBPACK FOOTER //
// ./components/footer/footer.js